// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.user__table__wrapper {
  width: 100%;
  overflow: hidden;
  overflow: auto;
}

.user__table {
  width: 100%;
  min-width: 1024px;
  border-color: #f9f9f9;
  border-collapse: collapse;
}

.user__table > thead > tr > th {
  padding: 25px 10px;
  text-align: left;
  font-size: 14px;
  font-weight: 300;
  color: #b6bdc8;
}

.user__table > tbody > tr > td {
  padding: 25px 10px;
  font-size: 14px;
  font-weight: 300;
  color: #424242;

  color: #424242;
  font-size: 14px;
  font-weight: 500;
}

.user__table > tbody > :first-child :first-child {
  border-top-left-radius: 8px;
}

.user__table > tbody > :first-child :last-child {
  border-top-right-radius: 8px;
}

.user__table > tbody > :last-child :first-child {
  border-bottom-left-radius: 8px;
}

.user__table > tbody > :last-child :last-child {
  border-bottom-right-radius: 8px;
}

.user__table > tbody > :nth-child(odd) {
  background-color: #dde1eb;
}

.user__table > tbody > :nth-child(even) {
  background-color: #f9f9f9;
}

/* .user__table > tbody > :nth-child(odd) > :first-child {
  border-radius: 8px 0 0 8px;
  overflow: hidden;
}

.user__table > tbody > :nth-child(even) > :first-child {
  border-radius: 8px 0 0 8px;
  overflow: hidden;
}

.user__table > tbody > :nth-child(odd) > :last-child {
  border-radius: 0 8px 8px 0;
  overflow: hidden;
}

.user__table > tbody > :nth-child(even) > :last-child {
  border-radius: 0 8px 8px 0;
  overflow: hidden;
} */

.user__table > tbody > tr > :last-child {
  text-align: left;
}

.users_actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.users_actions > button, .users_actions > a > button {
  padding: 0 10px;
  height: 35px;
  border: 1px solid #b2bac6;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: #0c6b60;
  font-size: 13px;
  font-weight: 500;
}

.users_actions > :last-child {
  border-color: #e0383d;
  color: #e0383d;
}


.list_filter
{
  display: flex;
    gap: 8px;
    padding: 0 16px;
}

.list_filter > a
{
  padding: 0 10px;
    border: 1px solid #b2bac6;
    border-radius: 8px;
    background: transparent;
    cursor: pointer;
    color: #0c6b60;
    font-size: 13px;
    font-weight: 500;
    padding: 10px;
}

.list_filter > a.active 
{
  background: #0c6b60;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/user/user.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;GAkBG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;;AAGA;;EAEE,aAAa;IACX,QAAQ;IACR,eAAe;AACnB;;AAEA;;EAEE,eAAe;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".user {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n}\n\n.user__table__wrapper {\n  width: 100%;\n  overflow: hidden;\n  overflow: auto;\n}\n\n.user__table {\n  width: 100%;\n  min-width: 1024px;\n  border-color: #f9f9f9;\n  border-collapse: collapse;\n}\n\n.user__table > thead > tr > th {\n  padding: 25px 10px;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 300;\n  color: #b6bdc8;\n}\n\n.user__table > tbody > tr > td {\n  padding: 25px 10px;\n  font-size: 14px;\n  font-weight: 300;\n  color: #424242;\n\n  color: #424242;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.user__table > tbody > :first-child :first-child {\n  border-top-left-radius: 8px;\n}\n\n.user__table > tbody > :first-child :last-child {\n  border-top-right-radius: 8px;\n}\n\n.user__table > tbody > :last-child :first-child {\n  border-bottom-left-radius: 8px;\n}\n\n.user__table > tbody > :last-child :last-child {\n  border-bottom-right-radius: 8px;\n}\n\n.user__table > tbody > :nth-child(odd) {\n  background-color: #dde1eb;\n}\n\n.user__table > tbody > :nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n/* .user__table > tbody > :nth-child(odd) > :first-child {\n  border-radius: 8px 0 0 8px;\n  overflow: hidden;\n}\n\n.user__table > tbody > :nth-child(even) > :first-child {\n  border-radius: 8px 0 0 8px;\n  overflow: hidden;\n}\n\n.user__table > tbody > :nth-child(odd) > :last-child {\n  border-radius: 0 8px 8px 0;\n  overflow: hidden;\n}\n\n.user__table > tbody > :nth-child(even) > :last-child {\n  border-radius: 0 8px 8px 0;\n  overflow: hidden;\n} */\n\n.user__table > tbody > tr > :last-child {\n  text-align: left;\n}\n\n.users_actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.users_actions > button, .users_actions > a > button {\n  padding: 0 10px;\n  height: 35px;\n  border: 1px solid #b2bac6;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  color: #0c6b60;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.users_actions > :last-child {\n  border-color: #e0383d;\n  color: #e0383d;\n}\n\n\n.list_filter\n{\n  display: flex;\n    gap: 8px;\n    padding: 0 16px;\n}\n\n.list_filter > a\n{\n  padding: 0 10px;\n    border: 1px solid #b2bac6;\n    border-radius: 8px;\n    background: transparent;\n    cursor: pointer;\n    color: #0c6b60;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 10px;\n}\n\n.list_filter > a.active \n{\n  background: #0c6b60;\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
